import { Icon } from '@fabric/icon';
import React, { FunctionComponent, PropsWithChildren } from 'react';

import { FullScreenModalTitleProps } from '../../full-screen-modal.types';

import { StyledIcon, StyledRoot } from './styles';
import { ifFeature } from '@bamboohr/utils/lib/feature';
import { Headline } from '~components/headline';
import { useScreenSizes } from '~utils';

export const Title: FunctionComponent<PropsWithChildren<FullScreenModalTitleProps>> = props => {
	const { children, icon, text } = props;

	const { isMediumScreen } = useScreenSizes(true);

	return (
		<StyledRoot>
			{icon ? <StyledIcon>{typeof icon === 'string' ? <Icon brand={true} name={icon} /> : icon}</StyledIcon> : null}
			{text ? ifFeature('encore', <Headline size={isMediumScreen ? 'small' : 'large'}>{text}</Headline>, <h2>{text}</h2>) : null}
			{children}
		</StyledRoot>
	);
};
